import React from 'react';
import { Formik } from 'formik';
import { noop } from 'lodash';

import CardDialog from '~/components/CardDialog';
import DialogFooterActions from '~/components/core/DialogFooterActions';
import type { DocumentType } from '~/components/types/document-type';

import DocumentTypeFormFields, { DOCUMENT_TYPE_FORMIK_IDS } from './DocumentTypeFormFields';

interface ViewDocumentTypeDialogProps {
  documentType: DocumentType;
  onClose: () => void;
}

const ViewDocumentTypeDialog: React.FC<ViewDocumentTypeDialogProps> = ({ documentType, onClose }) => {
  return (
    <Formik
      initialValues={{
        [DOCUMENT_TYPE_FORMIK_IDS.DISPLAY_NAME]: documentType.display_name ?? '',
        [DOCUMENT_TYPE_FORMIK_IDS.DESCRIPTION]: documentType.description ?? '',
        [DOCUMENT_TYPE_FORMIK_IDS.KEY]: documentType.key ?? '',
        [DOCUMENT_TYPE_FORMIK_IDS.IS_ALL_LOBS]: documentType.is_all_lobs ?? false,
        [DOCUMENT_TYPE_FORMIK_IDS.LOBS]: documentType.lobs ?? [],
        [DOCUMENT_TYPE_FORMIK_IDS.CLIVE_INSTRUCTIONS]: documentType.clive_instructions ?? '',
        [DOCUMENT_TYPE_FORMIK_IDS.CONFIGURATION]: {
          configured_fields: documentType.configuration?.configured_fields ?? [],
        },
      }}
      onSubmit={noop}
    >
      <CardDialog
        title="View Document Type"
        isDialog
        onClose={onClose}
        maxWidth="lg"
        fullWidth
        footerActions={<DialogFooterActions onClickSecondary={onClose} showPrimary={false} secondaryLabel="Close" />}
      >
        <DocumentTypeFormFields
          isUpdateMode
          originalIsAllLobs={documentType.is_all_lobs}
          originalLobs={documentType.lobs}
          readOnly
        />
      </CardDialog>
    </Formik>
  );
};

export default ViewDocumentTypeDialog;
